// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 353 ? "reactPlayerPreview" : chunkId) + "." + {"353":"3135cf8c","453":"07a6ab98","774":"bdd95bb9"}[chunkId] + ".chunk.js";
};